// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar flex layout — keeps promo card visible at bottom */
.sidebar-layout {
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
  padding-bottom: 0 !important;
}

.sidebar-layout .navbar-brand-box {
  flex-shrink: 0;
}

.sidebar-layout .sidebar-logo-light {
  width: 154px;
  max-width: 100%;
  height: auto;
}

.sidebar-layout .sidebar-menu-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

.sidebar-layout .sidebar-menu-scroll [data-simplebar] {
  height: 100%;
}

.sidebar-layout .sidebar-menu-scroll .simplebar-wrapper,
.sidebar-layout .sidebar-menu-scroll .simplebar-mask,
.sidebar-layout .sidebar-menu-scroll .simplebar-offset,
.sidebar-layout .sidebar-menu-scroll .simplebar-content-wrapper {
  height: 100% !important;
}

.sidebar-layout .sidebar-promo-wrap {
  flex-shrink: 0;
  position: relative;
  z-index: 2;
}

/* Force dark sidebar colors (theme defaults to light gray in light mode) */
:root {
  --bs-vertical-menu-bg-dark: #405189;
  --bs-vertical-menu-item-color-dark: #abb9e8;
  --bs-vertical-menu-item-hover-color-dark: #fff;
  --bs-vertical-menu-item-active-color-dark: #fff;
  --bs-vertical-menu-sub-item-color-dark: #abb9e8;
  --bs-vertical-menu-sub-item-hover-color-dark: #fff;
  --bs-vertical-menu-sub-item-active-color-dark: #fff;
  --bs-vertical-menu-title-color-dark: #838fb9;
}

[data-layout="vertical"][data-sidebar="dark"] .navbar-menu,
[data-layout="vertical"][data-sidebar="dark"] .navbar-brand-box {
  background: #21146b !important;
  border-color: #4b38b3 !important;
}

[data-layout="vertical"][data-sidebar="dark"] .logo-dark {
  display: none !important;
}

[data-layout="vertical"][data-sidebar="dark"] .logo-light {
  display: block !important;
}

/* Dark sidebar — submenu links (fix purple/dark text on dark bg) */
[data-layout="vertical"][data-sidebar="dark"]
  .navbar-menu
  .navbar-nav
  .menu-dropdown.show,
[data-layout="vertical"][data-sidebar="dark"]
  .navbar-menu
  .navbar-nav
  .nav-item:hover
  > .menu-dropdown.show {
  background-color: transparent !important;
}

[data-layout="vertical"][data-sidebar="dark"][data-layout-mode="light"]
  .navbar-menu
  .navbar-nav
  .nav-item:hover
  > .menu-dropdown {
  background-color: transparent !important;
}

[data-layout="vertical"][data-sidebar="dark"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-item:hover
  > .menu-dropdown {
  background-color: #364574 !important;
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link {
  color: #abb9e8 !important;
  background-color: transparent !important;
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-menu
  .navbar-nav
  .nav-link.menu-link:hover,
[data-layout="vertical"][data-sidebar="dark"]
  .navbar-menu
  .navbar-nav
  .nav-link.menu-link[aria-expanded="true"] {
  color: #fff !important;
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link:hover,
[data-layout="vertical"][data-sidebar="dark"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-item:hover
  > .nav-link,
[data-layout="vertical"][data-sidebar="dark"][data-layout-mode="light"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-item.active
  > .nav-link,
[data-layout="vertical"][data-sidebar="dark"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-item.active
  > .nav-link,
[data-layout="vertical"][data-sidebar="dark"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link.active {
  color: #fff !important;

}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-item.active
  > .nav-link {
  font-weight: 500;
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link:before {
  background-color: #abb9e8 !important;
  opacity: 0.8;
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link:hover:before,
[data-layout="vertical"][data-sidebar="dark"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-item.active
  > .nav-link:before,
[data-layout="vertical"][data-sidebar="dark"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link.active:before {
  background-color: #fff !important;
  opacity: 1 !important;
}

[data-layout="vertical"][data-sidebar="dark"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-item:hover
  > a.menu-link {
  color: #fff !important;
  background-color: #364574 !important;
}

[data-layout="vertical"][data-sidebar="dark"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-item:hover
  > a.menu-link:after {
  color: #fff !important;
}

/* Sidebar promo card */
.sidebar-promo-card {
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.12) 0%,
    rgba(255, 255, 255, 0.04) 100%
  ) !important;
  border: 1px solid rgba(255, 255, 255, 0.14) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.sidebar-promo-card .sidebar-promo-title {
  color: #fff !important;
}

.sidebar-promo-card .sidebar-promo-text {
  color: #abb9e8 !important;
}

/* Dashboard stat cards */
.dashboard-greeting {
  color: #21146b !important;
  font-size: 20px;
  font-weight: 700 !important;
  letter-spacing: -0.01em;
}

.dashboard-greeting-text {
  color: #3d3858 !important;
  font-size: 14px;
  font-weight: 600;
}

.dashboard-stat-card .dashboard-stat-icon {
  width: 48px;
  height: 48px;
  background-color: #21146b !important;
  color: #fff !important;
}

.dashboard-stat-card {
  border: 0;
  border-top: 3px solid #21146b;
  box-shadow: 0 8px 24px rgba(33, 20, 107, 0.08);
}

.dashboard-stat-label {
  color: #3a3458;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.dashboard-stat-count {
  color: #21146b !important;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.1;
}

.dashboard-stat-link {
  color: #21146b !important;
  font-size: 13px;
  font-weight: 700;
}

.dashboard-stat-link:hover {
  color: #3d2d8f !important;
}

.dashboard-activity-card {
  border: 0;
  border-top: 3px solid #21146b;
  box-shadow: 0 8px 24px rgba(33, 20, 107, 0.08);
}

.dashboard-panel-title {
  color: #21146b !important;
  font-weight: 700 !important;
}

.dashboard-activity-card .btn-soft-primary {
  color: #21146b;
  background-color: #efeafc;
  font-weight: 700;
}

.dashboard-activity-item {
  display: flex;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid #f1f2f6;
}

.dashboard-activity-item .flex-grow-1 {
  min-width: 0;
}

.dashboard-activity-item:first-child {
  padding-top: 0;
}

.dashboard-activity-item:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.dashboard-activity-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
  background: #21146b;
  color: #fff;
}

.dashboard-activity-name {
  color: #21146b !important;
  font-size: 15px;
  font-weight: 700 !important;
}

.dashboard-activity-date,
.dashboard-activity-meta {
  color: #3a3458 !important;
  font-weight: 600;
}

.dashboard-activity-chip {
  color: #21146b !important;
  background: #efeafc !important;
  border: 1px solid #ddd6f5;
  font-weight: 700;
}

/* Shared manage tables */
.card-header h5 {
  color: #21146b;
  font-weight: 700;
}

[data-layout-mode="light"] .manage-page-group-table-header {
  background-color: #f4f1fb;
}

[data-layout-mode="light"] .manage-page-group-table-header th {
  color: #21146b;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.manage-page-group,
.manage-page-group-table-values td,
.manage-property-owner-table-values td {
  color: #21146b;
  font-size: 14px;
  font-weight: 600;
}

[data-layout-mode="light"] .manage-page-group-table-values td,
[data-layout-mode="light"] .manage-property-owner-table-values td {
  color: #21146b;
  font-weight: 600;
}

.manage-page-group:hover {
  background-color: #f7f5fc;
}

.table-results-text {
  color: #3a3458;
  font-weight: 600;
}

.table-results-text span {
  color: #21146b;
  font-weight: 700;
}

/* Add / update job form */
.job-form-title {
  color: #21146b !important;
  font-weight: 700 !important;
}

.job-form-card {
  border: 0;
  border-top: 3px solid #21146b;
  box-shadow: 0 8px 24px rgba(33, 20, 107, 0.08);
}

.job-form-card h5 {
  color: #21146b !important;
  font-weight: 700 !important;
}

.job-form .form-label {
  color: #21146b;
  font-size: 13px;
  font-weight: 700;
}

.job-form .required-field {
  color: #21146b;
}

.job-form .form-control {
  color: #21146b;
  font-weight: 600;
  border: 1px solid #d9d3ee;
  background-color: #fff;
  box-shadow: none;
}

.job-form .form-control::placeholder {
  color: #6d6788;
  font-weight: 600;
}

.job-form .form-control:focus {
  color: #21146b;
  border-color: #21146b;
  box-shadow: 0 0 0 0.15rem rgba(33, 20, 107, 0.15);
}

.job-form .tox-tinymce {
  border: 1px solid #d9d3ee !important;
  border-radius: 0.25rem;
}

.job-form .tox .tox-edit-area__iframe {
  background-color: #fff;
}

/* Product list: featured flag */
.featured-product-checkbox .form-check-input {
  width: 1.35rem;
  height: 1.35rem;
  margin-top: 0;
  cursor: pointer;
  border: 2px solid #0056ff;
  border-radius: 0.35rem;
  box-shadow: 0 2px 5px rgba(247, 184, 75, 0.22);
}

.featured-product-checkbox .form-check-input:checked {
  background-color: #180f5a;
  border-color: #0056ff;
}

.featured-product-checkbox .form-check-input:focus {
  border-color: #0056ff;
  box-shadow: 0 0 0 0.25rem rgba(247, 184, 75, 0.3);
}

.featured-product-checkbox .form-check-input:disabled {
  cursor: not-allowed;
}

/* Role access: grouped permission matrix */
.role-access-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.role-access-search-wrap {
  position: relative;
  width: 260px;
  max-width: 100%;
}

.role-access-search-wrap i {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #878a99;
  font-size: 16px;
  pointer-events: none;
}

.role-access-search-wrap .form-control {
  padding-left: 36px;
}

.role-access-group {
  border: 1px solid #e9ebec;
  border-radius: 4px;
  margin-bottom: 16px;
  overflow: hidden;
  background: #fff;
}

.role-access-group:last-child {
  margin-bottom: 0;
}

.role-access-group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ebec;
}

.role-access-group-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 0;
  background: transparent;
  padding: 0;
  font-weight: 600;
  font-size: 14px;
  color: #212529;
}

.role-access-group-title i {
  font-size: 18px;
  color: #878a99;
}

.role-access-group-meta {
  font-size: 12px;
  font-weight: 500;
  color: #878a99;
}

.role-access-group-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.role-access-table thead th {
  font-size: 12px;
  font-weight: 600;
  color: #878a99;
  background: #fff;
  border-bottom-color: #e9ebec;
}

.role-access-table tbody tr:hover td {
  background: #fafbfc;
}

.role-access-col {
  text-align: center;
  width: 96px;
}

.role-access-page {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 180px;
}

.role-access-page-name {
  font-weight: 500;
  color: #212529;
}

.role-access-link {
  font-size: 12px;
  color: #878a99;
}

.role-access-all-row td {
  background: #f8f9fa;
}

.role-access-all-row .role-access-page-name {
  font-weight: 600;
}

.role-access-table tr.is-saving {
  opacity: 0.55;
}

.role-access-table .access-switch {
  display: inline-flex;
  justify-content: center;
  padding-left: 0;
  min-height: 1.25rem;
}

.role-access-table .access-switch .form-check-input {
  cursor: pointer;
  float: none;
  margin: 0;
}

.role-access-table .access-switch .form-check-input:indeterminate {
  background-image: none;
}

.role-access-table .access-switch.is-mixed .form-check-input::before {
  left: 6px;
  right: auto;
}

[data-layout-mode="dark"] .role-access-group {
  background: transparent;
  border-color: rgba(255, 255, 255, 0.08);
}

[data-layout-mode="dark"] .role-access-group-header,
[data-layout-mode="dark"] .role-access-all-row td {
  background: rgba(255, 255, 255, 0.04);
}

[data-layout-mode="dark"] .role-access-group-title,
[data-layout-mode="dark"] .role-access-page-name {
  color: #fff;
}

.bls-date-input {
  color: #21146b !important;
  font-weight: 600;
}

.bls-calendar.flatpickr-calendar {
  border: 0;
  border-radius: 10px;
  border-top: 3px solid #21146b;
  box-shadow: 0 12px 28px rgba(33, 20, 107, 0.16);
  font-family: inherit;
}

.bls-calendar .flatpickr-months {
  background: #21146b;
  border-radius: 8px 8px 0 0;
  padding: 6px 0 2px;
}

.bls-calendar .flatpickr-months .flatpickr-month,
.bls-calendar .flatpickr-current-month,
.bls-calendar .flatpickr-current-month .flatpickr-monthDropdown-months,
.bls-calendar .flatpickr-current-month input.cur-year {
  color: #fff !important;
  font-weight: 700;
  background: transparent;
}

.bls-calendar .flatpickr-months .flatpickr-prev-month,
.bls-calendar .flatpickr-months .flatpickr-next-month {
  color: #fff !important;
  fill: #fff !important;
}

.bls-calendar .flatpickr-months .flatpickr-prev-month svg,
.bls-calendar .flatpickr-months .flatpickr-next-month svg {
  fill: #fff !important;
}

.bls-calendar span.flatpickr-weekday {
  color: #21146b;
  font-weight: 700;
  background: #f4f1fb;
}

.bls-calendar .flatpickr-weekdays {
  background: #f4f1fb;
}

.bls-calendar .flatpickr-day {
  color: #21146b;
  font-weight: 600;
  border-radius: 6px;
}

.bls-calendar .flatpickr-day.today {
  border-color: #21146b;
}

.bls-calendar .flatpickr-day:hover,
.bls-calendar .flatpickr-day:focus {
  background: #efeafc;
  border-color: #efeafc;
  color: #21146b;
}

.bls-calendar .flatpickr-day.selected,
.bls-calendar .flatpickr-day.selected:hover,
.bls-calendar .flatpickr-day.selected:focus {
  background: #21146b;
  border-color: #21146b;
  color: #fff;
  font-weight: 700;
}

.bls-calendar .flatpickr-day.prevMonthDay,
.bls-calendar .flatpickr-day.nextMonthDay {
  color: #9a94b5;
}

.bls-calendar .flatpickr-footer {
  display: flex;
  justify-content: space-between;
  padding: 8px 12px 10px;
  border-top: 1px solid #eeeaf8;
}

.bls-calendar .flatpickr-footer-btn {
  border: 0;
  background: transparent;
  color: #21146b;
  font-weight: 700;
  font-size: 13px;
  padding: 0;
}

.bls-detail-modal {
  border-radius: 12px !important;
  border-top: 3px solid #21146b !important;
  padding: 1.4rem 1.2rem 1.2rem !important;
}

.bls-detail-modal-title {
  color: #21146b !important;
  font-size: 22px !important;
  font-weight: 700 !important;
}

.bls-detail-modal-body {
  text-align: left !important;
  margin: 0.5rem 0 0 !important;
}

.bls-detail-row {
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 8px 14px;
  padding: 10px 0;
  border-bottom: 1px solid #eeeaf8;
}

.bls-detail-row:last-child {
  border-bottom: 0;
}

.bls-detail-label {
  color: #000;
  font-size: 13px;
  font-weight: 700;
}

.bls-detail-value {
  color: #21146b;
  font-weight: 600;
  word-break: break-word;
}

.bls-detail-link {
  color: #21146b;
  font-weight: 700;
  text-decoration: underline;
}

.bls-detail-link:hover {
  color: #3d2d8f;
}

.bls-resume-icon {
  color: #d32f2f;
  font-size: 22px;
  line-height: 1;
  text-decoration: none;
}

.bls-resume-icon:hover {
  color: #b71c1c;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/custom-overrides.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;EACE,wBAAwB;EACxB,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA,2EAA2E;AAC3E;EACE,mCAAmC;EACnC,2CAA2C;EAC3C,8CAA8C;EAC9C,+CAA+C;EAC/C,+CAA+C;EAC/C,kDAAkD;EAClD,mDAAmD;EACnD,4CAA4C;AAC9C;;AAEA;;EAEE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mEAAmE;AACnE;;;;;;;;;EASE,wCAAwC;AAC1C;;AAEA;;;;;EAKE,wCAAwC;AAC1C;;AAEA;;;;;EAKE,oCAAoC;AACtC;;AAEA;;;;;EAKE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;;;;;;;;EAQE,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4BE,sBAAsB;;AAExB;;AAEA;;;;;;EAME,gBAAgB;AAClB;;AAEA;;;;;EAKE,oCAAoC;EACpC,YAAY;AACd;;AAEA;;;;;;;;;;;;;;;;EAgBE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;;;;;EAKE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;;;;EAKE,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE;;;;cAIY;EACZ,sDAAsD;EACtD,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;EAGE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,6BAA6B;EAC7B,+CAA+C;EAC/C,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;;;EAIE,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Sidebar flex layout — keeps promo card visible at bottom */\n.sidebar-layout {\n  display: flex !important;\n  flex-direction: column !important;\n  overflow: hidden !important;\n  padding-bottom: 0 !important;\n}\n\n.sidebar-layout .navbar-brand-box {\n  flex-shrink: 0;\n}\n\n.sidebar-layout .sidebar-logo-light {\n  width: 154px;\n  max-width: 100%;\n  height: auto;\n}\n\n.sidebar-layout .sidebar-menu-scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.sidebar-layout .sidebar-menu-scroll [data-simplebar] {\n  height: 100%;\n}\n\n.sidebar-layout .sidebar-menu-scroll .simplebar-wrapper,\n.sidebar-layout .sidebar-menu-scroll .simplebar-mask,\n.sidebar-layout .sidebar-menu-scroll .simplebar-offset,\n.sidebar-layout .sidebar-menu-scroll .simplebar-content-wrapper {\n  height: 100% !important;\n}\n\n.sidebar-layout .sidebar-promo-wrap {\n  flex-shrink: 0;\n  position: relative;\n  z-index: 2;\n}\n\n/* Force dark sidebar colors (theme defaults to light gray in light mode) */\n:root {\n  --bs-vertical-menu-bg-dark: #405189;\n  --bs-vertical-menu-item-color-dark: #abb9e8;\n  --bs-vertical-menu-item-hover-color-dark: #fff;\n  --bs-vertical-menu-item-active-color-dark: #fff;\n  --bs-vertical-menu-sub-item-color-dark: #abb9e8;\n  --bs-vertical-menu-sub-item-hover-color-dark: #fff;\n  --bs-vertical-menu-sub-item-active-color-dark: #fff;\n  --bs-vertical-menu-title-color-dark: #838fb9;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"] .navbar-menu,\n[data-layout=\"vertical\"][data-sidebar=\"dark\"] .navbar-brand-box {\n  background: #21146b !important;\n  border-color: #4b38b3 !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"] .logo-dark {\n  display: none !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"] .logo-light {\n  display: block !important;\n}\n\n/* Dark sidebar — submenu links (fix purple/dark text on dark bg) */\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .menu-dropdown.show,\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item:hover\n  > .menu-dropdown.show {\n  background-color: transparent !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"][data-layout-mode=\"light\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item:hover\n  > .menu-dropdown {\n  background-color: transparent !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item:hover\n  > .menu-dropdown {\n  background-color: #364574 !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link {\n  color: #abb9e8 !important;\n  background-color: transparent !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link.menu-link:hover,\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link.menu-link[aria-expanded=\"true\"] {\n  color: #fff !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link:hover,\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-item:hover\n  > .nav-link,\n[data-layout=\"vertical\"][data-sidebar=\"dark\"][data-layout-mode=\"light\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-item.active\n  > .nav-link,\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-item.active\n  > .nav-link,\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link.active {\n  color: #fff !important;\n\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-item.active\n  > .nav-link {\n  font-weight: 500;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link:before {\n  background-color: #abb9e8 !important;\n  opacity: 0.8;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link:hover:before,\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-item.active\n  > .nav-link:before,\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link.active:before {\n  background-color: #fff !important;\n  opacity: 1 !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item:hover\n  > a.menu-link {\n  color: #fff !important;\n  background-color: #364574 !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item:hover\n  > a.menu-link:after {\n  color: #fff !important;\n}\n\n/* Sidebar promo card */\n.sidebar-promo-card {\n  background: linear-gradient(\n    135deg,\n    rgba(255, 255, 255, 0.12) 0%,\n    rgba(255, 255, 255, 0.04) 100%\n  ) !important;\n  border: 1px solid rgba(255, 255, 255, 0.14) !important;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n}\n\n.sidebar-promo-card .sidebar-promo-title {\n  color: #fff !important;\n}\n\n.sidebar-promo-card .sidebar-promo-text {\n  color: #abb9e8 !important;\n}\n\n/* Dashboard stat cards */\n.dashboard-greeting {\n  color: #21146b !important;\n  font-size: 20px;\n  font-weight: 700 !important;\n  letter-spacing: -0.01em;\n}\n\n.dashboard-greeting-text {\n  color: #3d3858 !important;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.dashboard-stat-card .dashboard-stat-icon {\n  width: 48px;\n  height: 48px;\n  background-color: #21146b !important;\n  color: #fff !important;\n}\n\n.dashboard-stat-card {\n  border: 0;\n  border-top: 3px solid #21146b;\n  box-shadow: 0 8px 24px rgba(33, 20, 107, 0.08);\n}\n\n.dashboard-stat-label {\n  color: #3a3458;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n}\n\n.dashboard-stat-count {\n  color: #21146b !important;\n  font-size: 30px;\n  font-weight: 700;\n  line-height: 1.1;\n}\n\n.dashboard-stat-link {\n  color: #21146b !important;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.dashboard-stat-link:hover {\n  color: #3d2d8f !important;\n}\n\n.dashboard-activity-card {\n  border: 0;\n  border-top: 3px solid #21146b;\n  box-shadow: 0 8px 24px rgba(33, 20, 107, 0.08);\n}\n\n.dashboard-panel-title {\n  color: #21146b !important;\n  font-weight: 700 !important;\n}\n\n.dashboard-activity-card .btn-soft-primary {\n  color: #21146b;\n  background-color: #efeafc;\n  font-weight: 700;\n}\n\n.dashboard-activity-item {\n  display: flex;\n  gap: 12px;\n  padding: 14px 0;\n  border-bottom: 1px solid #f1f2f6;\n}\n\n.dashboard-activity-item .flex-grow-1 {\n  min-width: 0;\n}\n\n.dashboard-activity-item:first-child {\n  padding-top: 0;\n}\n\n.dashboard-activity-item:last-child {\n  padding-bottom: 0;\n  border-bottom: 0;\n}\n\n.dashboard-activity-avatar {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 700;\n  flex-shrink: 0;\n  background: #21146b;\n  color: #fff;\n}\n\n.dashboard-activity-name {\n  color: #21146b !important;\n  font-size: 15px;\n  font-weight: 700 !important;\n}\n\n.dashboard-activity-date,\n.dashboard-activity-meta {\n  color: #3a3458 !important;\n  font-weight: 600;\n}\n\n.dashboard-activity-chip {\n  color: #21146b !important;\n  background: #efeafc !important;\n  border: 1px solid #ddd6f5;\n  font-weight: 700;\n}\n\n/* Shared manage tables */\n.card-header h5 {\n  color: #21146b;\n  font-weight: 700;\n}\n\n[data-layout-mode=\"light\"] .manage-page-group-table-header {\n  background-color: #f4f1fb;\n}\n\n[data-layout-mode=\"light\"] .manage-page-group-table-header th {\n  color: #21146b;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.manage-page-group,\n.manage-page-group-table-values td,\n.manage-property-owner-table-values td {\n  color: #21146b;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n[data-layout-mode=\"light\"] .manage-page-group-table-values td,\n[data-layout-mode=\"light\"] .manage-property-owner-table-values td {\n  color: #21146b;\n  font-weight: 600;\n}\n\n.manage-page-group:hover {\n  background-color: #f7f5fc;\n}\n\n.table-results-text {\n  color: #3a3458;\n  font-weight: 600;\n}\n\n.table-results-text span {\n  color: #21146b;\n  font-weight: 700;\n}\n\n/* Add / update job form */\n.job-form-title {\n  color: #21146b !important;\n  font-weight: 700 !important;\n}\n\n.job-form-card {\n  border: 0;\n  border-top: 3px solid #21146b;\n  box-shadow: 0 8px 24px rgba(33, 20, 107, 0.08);\n}\n\n.job-form-card h5 {\n  color: #21146b !important;\n  font-weight: 700 !important;\n}\n\n.job-form .form-label {\n  color: #21146b;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.job-form .required-field {\n  color: #21146b;\n}\n\n.job-form .form-control {\n  color: #21146b;\n  font-weight: 600;\n  border: 1px solid #d9d3ee;\n  background-color: #fff;\n  box-shadow: none;\n}\n\n.job-form .form-control::placeholder {\n  color: #6d6788;\n  font-weight: 600;\n}\n\n.job-form .form-control:focus {\n  color: #21146b;\n  border-color: #21146b;\n  box-shadow: 0 0 0 0.15rem rgba(33, 20, 107, 0.15);\n}\n\n.job-form .tox-tinymce {\n  border: 1px solid #d9d3ee !important;\n  border-radius: 0.25rem;\n}\n\n.job-form .tox .tox-edit-area__iframe {\n  background-color: #fff;\n}\n\n/* Product list: featured flag */\n.featured-product-checkbox .form-check-input {\n  width: 1.35rem;\n  height: 1.35rem;\n  margin-top: 0;\n  cursor: pointer;\n  border: 2px solid #0056ff;\n  border-radius: 0.35rem;\n  box-shadow: 0 2px 5px rgba(247, 184, 75, 0.22);\n}\n\n.featured-product-checkbox .form-check-input:checked {\n  background-color: #180f5a;\n  border-color: #0056ff;\n}\n\n.featured-product-checkbox .form-check-input:focus {\n  border-color: #0056ff;\n  box-shadow: 0 0 0 0.25rem rgba(247, 184, 75, 0.3);\n}\n\n.featured-product-checkbox .form-check-input:disabled {\n  cursor: not-allowed;\n}\n\n/* Role access: grouped permission matrix */\n.role-access-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.role-access-search-wrap {\n  position: relative;\n  width: 260px;\n  max-width: 100%;\n}\n\n.role-access-search-wrap i {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #878a99;\n  font-size: 16px;\n  pointer-events: none;\n}\n\n.role-access-search-wrap .form-control {\n  padding-left: 36px;\n}\n\n.role-access-group {\n  border: 1px solid #e9ebec;\n  border-radius: 4px;\n  margin-bottom: 16px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.role-access-group:last-child {\n  margin-bottom: 0;\n}\n\n.role-access-group-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 16px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e9ebec;\n}\n\n.role-access-group-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: 0;\n  background: transparent;\n  padding: 0;\n  font-weight: 600;\n  font-size: 14px;\n  color: #212529;\n}\n\n.role-access-group-title i {\n  font-size: 18px;\n  color: #878a99;\n}\n\n.role-access-group-meta {\n  font-size: 12px;\n  font-weight: 500;\n  color: #878a99;\n}\n\n.role-access-group-actions {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.role-access-table thead th {\n  font-size: 12px;\n  font-weight: 600;\n  color: #878a99;\n  background: #fff;\n  border-bottom-color: #e9ebec;\n}\n\n.role-access-table tbody tr:hover td {\n  background: #fafbfc;\n}\n\n.role-access-col {\n  text-align: center;\n  width: 96px;\n}\n\n.role-access-page {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 180px;\n}\n\n.role-access-page-name {\n  font-weight: 500;\n  color: #212529;\n}\n\n.role-access-link {\n  font-size: 12px;\n  color: #878a99;\n}\n\n.role-access-all-row td {\n  background: #f8f9fa;\n}\n\n.role-access-all-row .role-access-page-name {\n  font-weight: 600;\n}\n\n.role-access-table tr.is-saving {\n  opacity: 0.55;\n}\n\n.role-access-table .access-switch {\n  display: inline-flex;\n  justify-content: center;\n  padding-left: 0;\n  min-height: 1.25rem;\n}\n\n.role-access-table .access-switch .form-check-input {\n  cursor: pointer;\n  float: none;\n  margin: 0;\n}\n\n.role-access-table .access-switch .form-check-input:indeterminate {\n  background-image: none;\n}\n\n.role-access-table .access-switch.is-mixed .form-check-input::before {\n  left: 6px;\n  right: auto;\n}\n\n[data-layout-mode=\"dark\"] .role-access-group {\n  background: transparent;\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n[data-layout-mode=\"dark\"] .role-access-group-header,\n[data-layout-mode=\"dark\"] .role-access-all-row td {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n[data-layout-mode=\"dark\"] .role-access-group-title,\n[data-layout-mode=\"dark\"] .role-access-page-name {\n  color: #fff;\n}\n\n.bls-date-input {\n  color: #21146b !important;\n  font-weight: 600;\n}\n\n.bls-calendar.flatpickr-calendar {\n  border: 0;\n  border-radius: 10px;\n  border-top: 3px solid #21146b;\n  box-shadow: 0 12px 28px rgba(33, 20, 107, 0.16);\n  font-family: inherit;\n}\n\n.bls-calendar .flatpickr-months {\n  background: #21146b;\n  border-radius: 8px 8px 0 0;\n  padding: 6px 0 2px;\n}\n\n.bls-calendar .flatpickr-months .flatpickr-month,\n.bls-calendar .flatpickr-current-month,\n.bls-calendar .flatpickr-current-month .flatpickr-monthDropdown-months,\n.bls-calendar .flatpickr-current-month input.cur-year {\n  color: #fff !important;\n  font-weight: 700;\n  background: transparent;\n}\n\n.bls-calendar .flatpickr-months .flatpickr-prev-month,\n.bls-calendar .flatpickr-months .flatpickr-next-month {\n  color: #fff !important;\n  fill: #fff !important;\n}\n\n.bls-calendar .flatpickr-months .flatpickr-prev-month svg,\n.bls-calendar .flatpickr-months .flatpickr-next-month svg {\n  fill: #fff !important;\n}\n\n.bls-calendar span.flatpickr-weekday {\n  color: #21146b;\n  font-weight: 700;\n  background: #f4f1fb;\n}\n\n.bls-calendar .flatpickr-weekdays {\n  background: #f4f1fb;\n}\n\n.bls-calendar .flatpickr-day {\n  color: #21146b;\n  font-weight: 600;\n  border-radius: 6px;\n}\n\n.bls-calendar .flatpickr-day.today {\n  border-color: #21146b;\n}\n\n.bls-calendar .flatpickr-day:hover,\n.bls-calendar .flatpickr-day:focus {\n  background: #efeafc;\n  border-color: #efeafc;\n  color: #21146b;\n}\n\n.bls-calendar .flatpickr-day.selected,\n.bls-calendar .flatpickr-day.selected:hover,\n.bls-calendar .flatpickr-day.selected:focus {\n  background: #21146b;\n  border-color: #21146b;\n  color: #fff;\n  font-weight: 700;\n}\n\n.bls-calendar .flatpickr-day.prevMonthDay,\n.bls-calendar .flatpickr-day.nextMonthDay {\n  color: #9a94b5;\n}\n\n.bls-calendar .flatpickr-footer {\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 12px 10px;\n  border-top: 1px solid #eeeaf8;\n}\n\n.bls-calendar .flatpickr-footer-btn {\n  border: 0;\n  background: transparent;\n  color: #21146b;\n  font-weight: 700;\n  font-size: 13px;\n  padding: 0;\n}\n\n.bls-detail-modal {\n  border-radius: 12px !important;\n  border-top: 3px solid #21146b !important;\n  padding: 1.4rem 1.2rem 1.2rem !important;\n}\n\n.bls-detail-modal-title {\n  color: #21146b !important;\n  font-size: 22px !important;\n  font-weight: 700 !important;\n}\n\n.bls-detail-modal-body {\n  text-align: left !important;\n  margin: 0.5rem 0 0 !important;\n}\n\n.bls-detail-row {\n  display: grid;\n  grid-template-columns: 110px 1fr;\n  gap: 8px 14px;\n  padding: 10px 0;\n  border-bottom: 1px solid #eeeaf8;\n}\n\n.bls-detail-row:last-child {\n  border-bottom: 0;\n}\n\n.bls-detail-label {\n  color: #000;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.bls-detail-value {\n  color: #21146b;\n  font-weight: 600;\n  word-break: break-word;\n}\n\n.bls-detail-link {\n  color: #21146b;\n  font-weight: 700;\n  text-decoration: underline;\n}\n\n.bls-detail-link:hover {\n  color: #3d2d8f;\n}\n\n.bls-resume-icon {\n  color: #d32f2f;\n  font-size: 22px;\n  line-height: 1;\n  text-decoration: none;\n}\n\n.bls-resume-icon:hover {\n  color: #b71c1c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
